export default "__VITE_ASSET__2dmgnO0o__"